module.exports = "<th>\n  Вход\n  <serp-filter-associated-objects filter-param=\"enter\"/>\n</th>\n<td>\n  <div class=\"filter__button-group\">\n    <term\n      source=\"source.enter\"\n      behavior=\"checkbox\"\n      text=\"Свободный\"\n      opposite=\"true\"/>\n\n    <term\n      source=\"source.enter\"\n      behavior=\"checkbox\"\n      text=\"По пропускам\"/>\n  </div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/commercial/enter.html
// module id = 326
// module chunks = 0